import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class ProjetoIdRequiredGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const url = state.url;
        const isV2Context = url.startsWith('/v2/');

        // V1: acesso liberado para adicionar e editar
        if (!isV2Context) {
            return true;
        }

        // V2: editar sempre permitido
        const isEditar = url.includes('/editar');
        if (isEditar) {
            return true;
        }

        // V2: adicionar somente permitido quando dentro do contexto de projetos
        const isAdicionar = url.includes('/adicionar');
        if (isAdicionar) {
            const isUnderProjetoContext = /\/v2\/projetos\/\d+\/ratoeiras\/adicionar(\?.*)?$/.test(url);
            if (isUnderProjetoContext) {
                return true;
            }
            // Fora do contexto de projetos, redireciona para a lista de projetos
            this.router.navigate(['/v2/projetos']);
            return false;
        }

        // Demais casos no V2: permitir
        return true;
    }
}
